import { Button, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router";
import { CREATE_URL, CHECK_USER_STATUS } from "../../../../const/URL.const";
import { useIsSuperuser } from "../../../../hooks/useIsSuperuser";

const useStyles = makeStyles({
  controllers: {
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    margin: "0 3.125rem 2.5rem",
  },
});

interface IUserManagementHeader{
  disabled:boolean;
}

const UserManagementHeader = ({ disabled }:IUserManagementHeader) => {
  const { isSuperuser } = useIsSuperuser();
  let { path } = useRouteMatch();
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();

  const onAddUserClick = () => {
    history.push(`${path}/${CREATE_URL}`);
  };
  const onCheckUserStatusClick = () => {
    history.push(`${path}/${CHECK_USER_STATUS}`);
  };
  return (
    <div className={classes.controllers}>
      <div>
        {isSuperuser && (
          <Button
            size="large"
            variant="contained"
            color="default"
            data-component-name="CREATE_NEW_USER"
            style={{ marginRight: 10 }}
            onClick={onCheckUserStatusClick}
            disabled={disabled}
          >
            {t("user_management.dialog.titleCheckUserStatus")}
          </Button>
        )}
        <Button
          size="large"
          variant="contained"
          color="primary"
          data-component-name="CREATE_NEW_USER"
          startIcon={<Add />}
          onClick={onAddUserClick}
          disabled={disabled}
        >
          {t("user_management.container.create")}
        </Button>
      </div>
    </div>
  );
};

export default UserManagementHeader;
